import styled from 'styled-components'

const StyledNotFound = styled.div`
  color: rgba(0, 0, 0, 0.25);
  font-size: 14px;
  padding: 16px;
  text-align: center;
`

export { StyledNotFound }
